"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _PhoneNumberVerificationWidget = _interopRequireDefault(require("./PhoneNumberVerificationWidget"));
var _components = require("../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var PhoneNumberVerificationModal = function PhoneNumberVerificationModal(_ref) {
  var visible = _ref.visible,
    loading = _ref.loading,
    phoneNumber = _ref.phoneNumber,
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? _lodash.noop : _ref$onSuccess,
    _ref$onCancel = _ref.onCancel,
    onCancel = _ref$onCancel === void 0 ? _lodash.noop : _ref$onCancel,
    _ref$onPhoneNumberUpd = _ref.onPhoneNumberUpdated,
    onPhoneNumberUpdated = _ref$onPhoneNumberUpd === void 0 ? _lodash.noop : _ref$onPhoneNumberUpd,
    _ref$includePhoneInpu = _ref.includePhoneInputStep,
    includePhoneInputStep = _ref$includePhoneInpu === void 0 ? false : _ref$includePhoneInpu,
    _ref$skippable = _ref.skippable,
    skippable = _ref$skippable === void 0 ? false : _ref$skippable;
  return /*#__PURE__*/_react.default.createElement(_components.Modal, {
    footer: null,
    visible: visible,
    maskClosable: false,
    onClose: onCancel
  }, /*#__PURE__*/_react.default.createElement(_PhoneNumberVerificationWidget.default, {
    loading: loading,
    includePhoneInputStep: includePhoneInputStep,
    skippable: skippable,
    phoneNumber: phoneNumber,
    onSuccess: onSuccess,
    onPhoneNumberUpdated: onPhoneNumberUpdated
  }));
};
var _default = PhoneNumberVerificationModal;
exports.default = _default;